import CommandsPool from "@kaspernj/api-maker/build/commands-pool"

const setLayout = (layout) => {
  const commandsPool = CommandsPool.current()

  if (!commandsPool.globalRequestData) commandsPool.globalRequestData = {}

  commandsPool.globalRequestData.layout = layout
}

export default setLayout
